var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"text-box"},[_c('h3',[_vm._v("非企业成员无法登陆")])]),_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("../assets/logo-c.png")}})])])
}]

export { render, staticRenderFns }